const FooterDescription = () => {
  return (
    <section className="py-3">
      <div className="container">
        <div className="row">
          <div className="col">
            <p>Patagonia, a legally viable name in the automobile sector, spoke to vehicle ‘ruggedness’ and was recommended for a partnership with the outdoor clothing/gear company of the same name. Though respondents were not so attracted to the name Evoq, Cadillac later used the neologism (made-up word) for a concept car that later became the CTS. Terrex referred to ‘terrain’ and ‘extreme,’ and respondents noted it had an ‘x-factor’ that signaled the ‘great unknown’. Compass evoked a positive response for having an ‘outdoor feel’; the name was later used by Jeep for its compact crossover vehicle.</p>
            <p>Finally, based on our QualiQuantitative, our brand name recommendation was the Escalde, which is now the best-selling model in it’s segment by a wide margin.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterDescription;